"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDraggingCurrentItem = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../model");
function useIsDraggingCurrentItem(sectionIndex, itemIndex) {
    var dragItem = model_1.useDashboardSelector(model_1.selectDraggingWidgetSource);
    return react_1.useMemo(function () {
        if (!dragItem) {
            return false;
        }
        return dragItem.sectionIndex === sectionIndex && dragItem.itemIndex === itemIndex;
    }, [dragItem, sectionIndex, itemIndex]);
}
exports.useIsDraggingCurrentItem = useIsDraggingCurrentItem;
//# sourceMappingURL=useIsDraggingCurrentItem.js.map